import { Box } from "@mui/material"
import React, { useMemo } from "react"

import { calculateSameTypeIndex } from "../../utils/calculateSameTypeIndex"

import type { CompanyPaymentType, CompanyPaymentTypeMethod, CompanyStatus } from "@/graphql/codegen/graphql"
import PaymentTypeCard from "@/screens/CompanySettings/Accounting/components/PaymentTypeDetails/PaymentTypeCard/PaymentTypeCard"

interface PaymentMethodsListProps {
  paymentTypes: CompanyPaymentType[]
  onAddPaymentMethod: () => void
  onDefaultChange?: (
    newDefault: CompanyPaymentTypeMethod,
    currentDefault?: CompanyPaymentTypeMethod | null
  ) => Promise<void>
  onRefetch?: () => void
  onDeleteType: (companyPaymentTypeId: string) => void
  onDeleteMethod: (companyPaymentMethodId: string) => void
  onToggleActivation: (methodId: string, currentStatus: CompanyStatus) => void
}

const PaymentMethodsList: React.FC<PaymentMethodsListProps> = ({
  paymentTypes,
  onAddPaymentMethod: _onAddPaymentMethod,
  onDefaultChange,
  onRefetch,
  onDeleteType,
  onDeleteMethod,
  onToggleActivation,
}) => {
  const sortedPaymentTypes = useMemo(() => {
    return paymentTypes.sort((a, b) => a.companyPaymentTypeId.localeCompare(b.companyPaymentTypeId))
  }, [paymentTypes])

  return (
    <Box>
      <Box className='space-y-4'>
        {sortedPaymentTypes.map((paymentType, index) => {
          const sameTypeIndex = calculateSameTypeIndex(paymentTypes, index)

          const handleDefaultChange = (paymentMethod: CompanyPaymentTypeMethod) => {
            // Find current default for the same account type from all payment types
            const currentDefault = paymentTypes
              .find((type) => type.accountType === paymentType.accountType)
              ?.paymentMethods?.find((method) => method?.isDefault)

            onDefaultChange?.(paymentMethod, currentDefault)
          }

          return (
            <PaymentTypeCard
              key={paymentType.companyPaymentTypeId}
              paymentType={paymentType}
              sameTypeIndex={sameTypeIndex}
              onRefetch={onRefetch}
              onDeleteType={onDeleteType}
              onDeleteMethod={onDeleteMethod}
              onDefaultChange={handleDefaultChange}
              onToggleActivation={onToggleActivation}
            />
          )
        })}
      </Box>
    </Box>
  )
}

export default PaymentMethodsList
